<template>
  <h2 :class="['section-title', { 'section-title--small': isSmall }]">
    <slot></slot>
  </h2>
</template>

<script>
export default {
  name: "SectionTitle",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSmall() {
      return this.small;
    },
  },
};
</script>

<style scoped>
.section-title {
  /* font-size: 2rem; */
  font-size: clamp(2rem, 0.1906rem + 6.7327vw, 6.25rem);
  line-height: 1.3125;
  text-transform: uppercase;
  color: inherit;
  font-weight: 400;
  text-align: right;
  text-align-last: left;
}

.section-title--small {
  /* font-size: 2rem; */
  font-size: clamp(2rem, 1.255rem + 2.7723vw, 3.7rem);
}

@media screen and (min-width: 768px) {
  .section-title {
    /* font-size: 6.25rem; */
    line-height: 1.1;
  }
  .section-title--small {
    /* font-size: 3.75rem; */
    line-height: 1.3;
  }
}
</style>
